export const version = { major: 1, minor: 2, build: 120 };
